import { SimpleItemList } from "./SimpleItemList";
import { ListItem } from "./ListItem";

export class ItemList extends SimpleItemList {
    protected createItem(data: string) {
        return new ListItem(data);
    }
}
